unit NetInstrumentType;

interface

uses
  InstrumentType, NetType, UserType;

type
  TNetInstrumentType = class
  private
    fNetInstrumentKey: String;
    fNet: TNetType;
    fInstrument: TInstrumentType;
    fAmountInNet: Byte;
    fIndexInNet: Byte;
    fToPin: Boolean;
    fCreationDate: String;
    fCreatedBy: TUserType;
    fChangedDate: String;
    fChangedBy: TUserType;
  public
    property NetInstrumentKey: String read fNetInstrumentKey;
    property Net: TNetType read fNet;
    property Instrument: TInstrumentType read fInstrument;
    property AmountInNet: Byte read fAmountInNet;
    property IndexInNet: Byte read fIndexInNet;
    property ToPin: Boolean read fToPin;
    property CreationDate: String read fCreationDate;
    property CreatedBy: TUserType read fCreatedBy;
    property ChangedDate: String read fChangedDate;
    property ChangedBy: TUserType read fChangedBy;
end;

implementation

end.
